import { Component, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { Paginator } from 'primeng/paginator';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { ProjectTaskServiceProxy, TeamTaskDto, UserProjectTaskDto, UserStatusEnum, UserTaskListDashBoard } from '../../../../../shared/service-proxies/service-proxies';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskListComponent extends AppComponentBase implements OnInit {
    @ViewChild("paginator", { static: true })
    paginator: Paginator;
    taskDetails: UserProjectTaskDto[];
    isLoaded = false;
    isTaskListRecordsEmpty = false;
    statusIdCheck: number = 1;
    //filters
    assignedUserIdFilter: number[];
    stateIdFilter: number;
    projectFilter: number[];
    filterSearch: string = "";
    newestOnTop: boolean = true;
    oldestOnTop: boolean = false;
    isLoading = false;
    visible = true;
    selectedTeamTask: TeamTaskDto;
    projectId: any[];
    projectTaskId: number[];
    taskList = [];
    taskDetailsNew: UserTaskListDashBoard[];
    dateTime = new Date();
    msg: string;
    constructor(private _monitorService: MonitoringService, injector: Injector, private router: Router, private _projectTaskServiceProxy: ProjectTaskServiceProxy, private AbpSession: AbpSessionService) { super(injector); }
    ngOnInit(): void {
        this.getDashboardTaskList();
    }
    viewall() {
        this.router.navigate([AppRoutes.timeTracking]);
    }
    getUserlength(e: string) {
        return e?.length;
    }
    //Updated API call for task-list data as per my task-list
      /*

}
*/
    async getDashboardTaskList() {
        this._monitorService.logTrace("UI-getDashboardTaskList", { "getDashboardTaskList ": "getDashboardTaskList: " + this.dateTime });
        await this._projectTaskServiceProxy.getTaskListForParticularUserDashBoard(this.AbpSession.userId, 5).subscribe(result => {
            this.taskDetailsNew = result;
            this.isLoaded = true;
            if (this.taskDetailsNew.length > 0) {
                this.isTaskListRecordsEmpty = true;
            }
            this.markForCheck();
        });
    }
    getOriginalEstimateHour(hour: number) {
        if (!hour)
            return "N/A";
        let hours = Math.floor(hour);
        let minutes = Math.floor((hour - Math.floor(hour)) * 60);
        return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes} h`;
    }
    getHrsAndMinutes(timestamp: string) {
        if (!timestamp)
            return '00h 00m';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }
    getUserStatus(id: UserStatusEnum) {
        return id != null ? UserStatusEnum[id] : "Unknown";
    }
}
